import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DevelopmentAPI} from "pages/workspace/process/development/development.service";
const initialState = {
  data: [],
  state: ""
};
export const epicSlice = createSlice({
  name: "epic",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getEpic.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getEpic.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getEpic = createAsyncThunk('sprints/get', async({ query, workspaceId }) => {
  let data = await DevelopmentAPI.getIssues({ issueType: 1 }, workspaceId);
  return data['tickets'];

});


export default epicSlice.reducer;